module.exports = __webpack_public_path__ + "img/antonenko.fcd478a3.png";